// Followers page + shared leftovers.
export const misc: Record<string, string> = {
  'Network': 'Mreža',
  'Could not load list. Please try again.': 'Lista nije mogla da se učita. Pokušaj ponovo.',
  // 'No followers yet' / 'Not following anyone yet' already live in profile.ts
  'Share your trades to attract followers': 'Podeli svoje trejdove da privučeš pratioce',
  'Discover traders on the leaderboard': 'Otkrij trejdere na rang listi',
  'Discover Traders': 'Otkrij trejdere',
  'profile picture': 'profilna slika',
  'Win': 'Uspeh',
};
